import { useState, useEffect } from "react";

import PropTypes from "prop-types";
import { useSelector } from "react-redux";

// material-ui
import { Box, List, Typography } from "@mui/material";

// project import
import NavItem from "./NavItem";
import usePermissions from "hooks/usePermissions";
import TokenService from "services/authentication/TokenService";

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

function Permission({
    permissions,
    hasAll,
    hasAny,
    doesNotHaveAll,
    doesNotHaveAny,
    children,
}) {
    const methods = usePermissions(permissions);
    const [hasPermission, setHasPermission] = useState(null);

    if (hasAll && hasPermission === null) {
        setHasPermission(methods.hasAll(hasAll));
    }

    if (hasAny && hasPermission === null) {
        setHasPermission(methods.hasAny(hasAny));
    }

    if (doesNotHaveAll && hasPermission === null) {
        setHasPermission(methods.doesNotHaveAll(doesNotHaveAll));
    }

    if (doesNotHaveAny && hasPermission === null) {
        setHasPermission(methods.doesNotHaveAny(doesNotHaveAny));
    }

    if (hasPermission) {
        return <>{children}</>;
    }

    return null;
}

const AuthorizedNavItem = ({ menuItem }) => {
    // const permissions = TokenService.getAuthPermissions();
    return (
        // <Permission permissions={permissions} hasAny={menuItem?.authority}>
        // </Permission>
        (<NavItem key={menuItem.id} item={menuItem} level={1} />)
    );
};

const NavGroup = ({ item }) => {
    const menu = useSelector((state) => state.menu);
    const { drawerOpen } = menu;

    const navCollapse = item.children?.map((menuItem, i) => {
        switch (menuItem.type) {
            case "item":
                return <AuthorizedNavItem key={i} menuItem={menuItem} />;
            default:
                return (
                    <Typography
                        key={menuItem.id}
                        variant="h6"
                        color="error"
                        align="center"
                    >
                        Fix - Group Collapse or Items
                    </Typography>
                );
        }
    });
    return (
        <List
            subheader={
                item.title &&
                drawerOpen && (
                    <Box sx={{ pl: 3, mb: 1.5 }}>
                        <Typography variant="subtitle2" color="textSecondary">
                            {item.title}
                        </Typography>
                        {/* only available in paid version */}
                    </Box>
                )
            }
            sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
        >
            {navCollapse}
        </List>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object,
};

export default NavGroup;
